import { CardText } from "../subComponents/cardText";

interface IActivityDescriptionProps {
  description: string;
}
export const ActivityDescription = ({ description }: IActivityDescriptionProps) => {
  return <CardText useMarkdown>{description}</CardText>;
};
